import React from 'react';
import { Badge, colors } from '@mui/material';

const DashboardBadge = (props) => (
  <Badge
    {...props}
    sx={{
      '& .MuiBadge-badge': {
        backgroundColor: colors.amber[600],
        color: colors.grey[900],
        right: -10,
      },
    }}
  />
);

export default DashboardBadge;
